import moment, { Moment } from 'moment';
import { TimeoffResponse } from 'api/timeoff/types';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { getDays } from './date-field/get-days-array';

export const numberOfWorkingDaysBetweenDatesForTimeoff = (
  startDate: Moment,
  endDate: Moment,
  workingDays: WorkingDaysConfiguration,
): number => {
  const totalNoOfDays = endDate.diff(startDate, 'day') + 1;

  return [...Array(totalNoOfDays)].reduce((noOfDays, _, index) => {
    const dayName = moment(startDate)
      .add(index, 'day')
      .locale('en')
      .format('dddd');

    return workingDays[dayName] ? noOfDays + 1 : noOfDays;
  }, 0);
};

export const checkIfCurrentDateHasTimeOff = (
  timeOffArray?: TimeoffResponse[],
  date = moment(),
): TimeoffResponse | undefined => {
  if (timeOffArray == null || timeOffArray.length === 0) {
    return undefined;
  }

  return timeOffArray.find((timeOff) =>
    date.isBetween(
      moment(timeOff.timeOffStart).startOf('day'),
      moment(timeOff.timeOffEnd).endOf('day'),
      undefined,
      '[]',
    ),
  );
};

export const getTimeOffArray = (
  startDate: Moment | undefined,
  endDate: Moment,
  userTimeOffArray: TimeoffResponse[] | undefined,
): TimeoffResponse[] | undefined => {
  if (startDate == null || endDate == null) {
    return undefined;
  }

  return userTimeOffArray
    ?.filter(
      (timeOffT) =>
        moment(timeOffT.timeOffStart).isBetween(
          startDate.startOf('day'),
          endDate.endOf('day'),
          undefined,
          '[]',
        ) ||
        moment(timeOffT.timeOffEnd).isBetween(
          startDate.startOf('day'),
          endDate.endOf('day'),
          undefined,
          '[]',
        ) ||
        moment(startDate).isBetween(
          moment(timeOffT.timeOffStart).startOf('day'),
          moment(timeOffT.timeOffEnd).endOf('day'),
          undefined,
          '[]',
        ) ||
        moment(endDate).isBetween(
          moment(timeOffT.timeOffStart).startOf('day'),
          moment(timeOffT.timeOffEnd).endOf('day'),
          undefined,
          '[]',
        ),
    )
    .sort((a, b) => {
      return moment.utc(a.timeOffStart).diff(moment.utc(b.timeOffStart));
    });
};

export const getTimeOffDaysInRange = (
  startDate: Moment,
  endDate: Moment,
  userTimeOffArray: TimeoffResponse[] | undefined,
  workingDaysConfig: WorkingDaysConfiguration,
): number => {
  let countOfDays = 0;

  userTimeOffArray?.forEach((timeOff) => {
    const newStartDate = moment(timeOff.timeOffStart).isBefore(startDate, 'day')
      ? startDate
      : moment(timeOff.timeOffStart).startOf('day');
    const newEndDate = moment(timeOff.timeOffEnd).isAfter(endDate, 'day')
      ? endDate
      : moment(timeOff.timeOffEnd).endOf('day');

    countOfDays += numberOfWorkingDaysBetweenDatesForTimeoff(
      newStartDate,
      newEndDate,
      workingDaysConfig,
    );
  });

  return countOfDays;
};

export const getTimeOffDaysInAWeek = (
  startDate: Moment,
  userTimeOffArray: TimeoffResponse[] | undefined,
): number => {
  const endDate = startDate.add(5, 'days');
  const timeOffInWeek = getTimeOffArray(startDate, endDate, userTimeOffArray);
  const days = getDays(startDate, 5);

  let countOfDays = 0;

  timeOffInWeek?.forEach((timeOff) => {
    days.forEach((day) => {
      if (
        moment(day).isBetween(
          moment(timeOff.timeOffStart).startOf('day'),
          moment(timeOff.timeOffEnd).endOf('day'),
          undefined,
          '[]',
        )
      ) {
        countOfDays += 1;
      }
    });
  });

  return countOfDays;
};

export const getStartDate = (dueDate) => {
  if (dueDate == null || moment().diff(dueDate, 'days') >= 1) {
    return undefined;
  }
  if (moment(dueDate).diff(new Date(), 'days') > 14) {
    return moment(dueDate).subtract(2, 'weeks');
  }

  return moment();
};
